module.exports = true;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/core-js/library/modules/_library.js
// module id = 246
// module chunks = 168707334958949